export default "__VITE_ASSET__9cfb190a__"